import axios from "axios";
import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import { useAuth } from "../contexts/AuthContext";
import constraints from "../constraints";

let intervalId = null;

export default function TaskImage() {
  const { currentUser } = useAuth();
  const [loading, setLoading] = useState(true);
  const [imageURLS, setImageURLS] = useState([]);
  const [prompt, setPrompt] = useState("");
  const [taskId, setTaskId] = useState("");

  const onClickShareChannel = () => {
    const kakao = window.Kakao;

    if (!kakao.isInitialized()) {
      kakao.init(constraints.config.KAKAO_JAVASCRIPT_KEY);
    }

    kakao.Link.sendDefault({
      objectType: "feed",
      content: {
        title: "대신 그려드려요",
        description: prompt,
        imageUrl: imageURLS[0],
        link: {
          mobileWebUrl: "http://pf.kakao.com/_cjxoxfxj",
          webUrl: "http://pf.kakao.com/_cjxoxfxj"
        },
      },
      buttons: [
        {
          title: "나도 그림 그려보기",
          link: {
            mobileWebUrl: "http://pf.kakao.com/_cjxoxfxj",
            webUrl: "http://pf.kakao.com/_cjxoxfxj"
          },
        },
      ],
      serverCallbackArgs: {
        taskId: taskId
      }
    });
  }

  useEffect(() => {
    async function init() {
      const params = new URLSearchParams(window.location.search);
      const taskId = params.get("taskId");

      intervalId = setInterval(() => {
        axios.get(`${constraints.config.API_URL}/user/task?taskId=${taskId}`).then((response) => {
          const data = response.data;
          const { prompt, images, taskStatus } = data.data;

          if (taskStatus == "PENDING") {
            return;
          }

          setPrompt(prompt);
          setImageURLS(images);
          setTaskId(taskId);
          setLoading(false);
          clearInterval(intervalId);
        }).catch((error) => {
          console.log(error);
        });
      }, 1500);
    }

    init();
  }, []);

  if (loading) {
    return (
      <div className="h-screen w-full flex flex-col justify-center items-center">
        <img src="/assets/gifs//imageLoading.gif" className="w-1/2" />

        <p className="text-2xl font-bold mt-4">그림을 그리는 중입니다...</p>

        <p className="text-base mt-2">약 5~15초 정도 소요됩니다.</p>
      </div>
    );
  }

  const renderCreatedImage = () => {
    if (imageURLS.length == 1) {
      return (
        <img src={imageURLS[0]} className="w-1/2 mb-7" />
      );
    }

    if (imageURLS.length == 3) {
      return (
        <div className="flex flex-col pl-5 pr-5">
          <div className="flex flex-row">
              <img src={imageURLS[0]} className="w-1/2 mb-7" />
              <img src={imageURLS[1]} className="w-1/2 mb-7" />
          </div>

          <img src={imageURLS[2]} className="w-1/2 mb-7 self-center" />
        </div>
      )
    }

    if (imageURLS.length == 4) {
      return (
        <div className="flex flex-col pl-5 pr-5">
          <div className="flex flex-row">
            <img src={imageURLS[0]} className="w-1/2 mb-7" />
            <img src={imageURLS[1]} className="w-1/2 mb-7" />
          </div>

          <div className="flex flex-row">
            <img src={imageURLS[2]} className="w-1/2 mb-7" />
            <img src={imageURLS[3]} className="w-1/2 mb-7" />
          </div>
        </div>
      );
    }
  }

  return (
    <div className="h-screen w-full flex flex-col">
      <Helmet>
        <script src="https://developers.kakao.com/sdk/js/kakao.js"></script>
      </Helmet>

      <div className="flex flex-1 flex-col justify-center items-center">
        { renderCreatedImage() }
        <h1 className="text-xl font-bold break-all pl-10 pr-10">{prompt}</h1>
      </div>
    

      <div className="rounded-lg pt-4 pb-4 pl-5 pr-5 flex flex-row items-center m-8" style={{ backgroundColor: "#FEE501" }}>

        <img src="/assets/imgs/channel.png" className="w-10 h-10 mr-3" />

        <div onClick={onClickShareChannel} className="flex flex-col flex-1 justify-center items-center cursor-pointer">
          <h1 className="text-base font-bold text-black mr-10 mb-1">대신그려드려요</h1>
          <h1 className="text-sm text-black mr-10">결과 공유하고 채널 초대하기</h1>
        </div>

        {/* <div className="flex flex-row justify-center items-center">
          <img src="/assets/imgs/channel.png" className="w-6 h-6 mr-3" />
          <h1 className="text-base font-bold text-black">대신그려드려요</h1>
        </div>

        <p className="text-sm text-black">채널 초대하기</p> */}
      </div>
    </div>
  )
}